import Axios from "axios";
import { useEffect, useReducer } from "react";
import { systemCode, xs_languageCode } from '..';
import { getConfiguration } from './utils/configuration';
import { dataFetchReducer } from "./utils/dataFetchReducer";
import { parseBetBuilderEvents } from "./parseBetBuilderEvents";

export function useFetchBetBuilderEvents(data, tournament, shouldExecute, reload) {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    useEffect(() => {
        if (!shouldExecute) {
            return;
        }
        
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await Axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        const url = getConfiguration().api.getBetBuilderEvents;
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            sportId: tournament.sportRef,
            categoryId: tournament.categoryRef,
            tournamentId: tournament.id
        }
        fetchData(url, params, function(response) {
            if (response == null || response === '') {
                dispatch({ type: 'FETCH_FAILURE' });
            }
            const betBuilderEvents = parseBetBuilderEvents(data, response, tournament.uniqueId);
            dispatch({ type: 'FETCH_SUCCESS', payload: betBuilderEvents });
        });
        
        return () => {
            didCancel = true;
        };
    }, [data, tournament, shouldExecute, reload]);

    return [state, dispatch];
}
